import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ModelPath } from "@com.mgmtp.a12.base/base-model-api/lib/main/model";

import { ValidationSlice } from "./types";

const initialState: ValidationSlice = {
	validationCodes: {},
	validationTargetFields: {}
};

export const {
	name: validationSliceName,
	actions: { setValidationCode, setValidationTargetFieldPaths },
	reducer: validationReducer
} = createSlice({
	name: "validation",
	initialState,
	reducers: {
		setValidationCode(state: ValidationSlice, action: PayloadAction<[string, string]>) {
			state.validationCodes[action.payload[0]] = action.payload[1];
		},
		setValidationTargetFieldPaths(
			state: ValidationSlice,
			{
				payload: { formModelId, validationTargetFieldPaths, screenPath }
			}: PayloadAction<{ formModelId: string; screenPath: ModelPath; validationTargetFieldPaths: string[] }>
		) {
			if (!state.validationTargetFields[formModelId]) {
				state.validationTargetFields[formModelId] = {};
			}
			state.validationTargetFields[formModelId][ModelPath.toString(screenPath)] = validationTargetFieldPaths;
		}
	}
});
